import React from 'react'

export function addForceMount(trigger: React.ReactElement, visible?: boolean) {
  return React.cloneElement(trigger, {
    forceMount: !!visible,
  })
}
